import clsx from 'clsx'
import React from 'react'

import {desktopClasses, desktopSystemClasses, mobileClasses, mobileSystemClasses} from './PaymentSystemIcon.classes'
import {PaymentSystemIconProps} from './PaymentSystemIcon.types'

export const PaymentSystemIcon: React.FC<PaymentSystemIconProps> = ({className, paymentSystem, mobile}) => {
  const {classes, systemClasses} = mobile
    ? {classes: mobileClasses, systemClasses: mobileSystemClasses}
    : {classes: desktopClasses, systemClasses: desktopSystemClasses}

  return <div className={clsx(classes.logo, paymentSystem && systemClasses[paymentSystem], className)} />
}
